import React from 'react';
import Moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Launch from '@material-ui/icons/Launch';
import { Link } from 'react-router-dom';
import { DASHBOARD } from '../Routes/routes';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  button: {
    margin: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
    color: 'dodgerblue',
    display: 'flex',
    alignItems: 'center',
  },
}));

const ProductsTable = props => {
  const classes = useStyles();
  const { products } = props;

  return (

    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell>Dato</TableCell>
              <TableCell>Navn</TableCell>
              <TableCell>Art</TableCell>
              <TableCell>Størrelse</TableCell>
              <TableCell>Alder</TableCell>
              <TableCell>Proveniens</TableCell>
              <TableCell>Antal</TableCell>
              <TableCell>Kasse</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {products && products.length > 0 ? (
              products.map(product => (
                <TableRow key={product.id}>
                  <TableCell>
                    {Moment(product.createdAt.toDate()).format('Do MMMM YY')}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`${DASHBOARD}/${product.productBox}/${product.id}/edit`}
                      className={classes.link}>
                      <Launch />
                      {product.name}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`${DASHBOARD}/species/${product.art}`}
                      className={classes.link}>
                      <Launch />
                      {product.art}
                    </Link>
                  </TableCell>
                  <TableCell>{product.age}</TableCell>
                  <TableCell>{product.size}</TableCell>
                  <TableCell>{product.proveniens}</TableCell>
                  <TableCell>{product.amount}</TableCell>
                  <TableCell>
                    <Link
                      to={`${DASHBOARD}/${product.productBox}`}
                      className={classes.link}
                    >
                      <Launch />
                      {product.productBox}
                    </Link>
                  </TableCell>
                </TableRow>
              ))
            ) : (
                <TableRow>
                  <TableCell>Ingen nyelige tilføjet planet</TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </Paper>
    </Grid>
  );
};

export default ProductsTable;
